import script from "./RemittanceSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./RemittanceSummary.vue?vue&type=script&setup=true&lang=js"

import "./RemittanceSummary.vue?vue&type=style&index=0&id=065d5e3e&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-065d5e3e"]])

export default __exports__